"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bankSlipSave = bankSlipSave;
exports.doBtnClickDOF = doBtnClickDOF;
exports.openDialog = openDialog;
exports.querySysAccountPort = querySysAccountPort;
exports.search = search;
exports.setDownloadFile = setDownloadFile;
var _request = _interopRequireDefault(require("@/utils/request"));
// 查询
function search(listQuery, blNos, pod) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirmIn/search?blNos=".concat(blNos, "&currentPag=").concat(listQuery.currentPage, "&pageSize=").concat(listQuery.pageSize, "&pod=").concat(pod),
    method: 'get'
  });
}

//打开弹窗 打开费率转换的对话框
function openDialog(amountStr, idBlNos) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirmIn/openDialog?amountStr=".concat(amountStr, "&idBlNos=").concat(idBlNos),
    method: 'get'
  });
}
//换单费DOF现场支付接口
function doBtnClickDOF(data) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirmIn/doBtnClickDOF",
    method: 'post',
    data: data
  });
}

//进口账单及水单保存水单
function bankSlipSave(data) {
  return (0, _request.default)({
    url: "/ebusiness/feeConfirmIn/bankSlipSave",
    method: 'post',
    data: data
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // }
  });
}
//下载文件
function setDownloadFile(url) {
  return (0, _request.default)({
    responseType: 'blob',
    url: url,
    method: 'get'
  });
}

//查询港口权限
function querySysAccountPort() {
  return (0, _request.default)({
    url: "/sitceb-system-service/ebSysAccount/querySysAccountPort",
    method: 'post'
  });
}